


























import Vue from 'vue'
// @ts-ignore
import _ from 'lodash'
import { TranslateResult } from 'vue-i18n'
import { SnackbarStateEnum } from '@/types/enums'
import { GET_SELECTED_UI_LANGUAGE } from '@/store/getter-types'
import NumberField from '@/components/NumberField.vue'


interface ComponentData {
  showSnackbar: boolean
  snackbarState: number
  messageSnackbar: TranslateResult | string
  valid: boolean
  inSaveProgress: boolean

  lagerhilfsmittelList: any[]
  lagerhilfsmittel: any | null
  einlagermenge: number | null
  lagereigenschaftList: any[]
  lagereigenschaft: any | null
}

export default Vue.extend({
  name: 'ProductLogistic',

  components: {
    NumberField,
  },

  props: {
    productId: Number,
    selectedProductUnitId: Number,
    selectedLagerungenId: Number,
    storageMetaData: Object as () => any,
    storageData: Object as () => any,
    isCreate: Boolean,
    isUpdate: Boolean,
    loading: Boolean
  },

  data (): ComponentData {
    //const required = (value: any): boolean | string => !!value || ''

    return {
      showSnackbar: false,
      snackbarState: 0,
      messageSnackbar: '',
      valid: true,
      inSaveProgress: false,

      lagerhilfsmittelList: [],
      lagerhilfsmittel: null,
      einlagermenge: null,
      lagereigenschaftList: [],
      lagereigenschaft: null
    }
  },

  watch: {
    isCreate (newVal: boolean): void {
      if(newVal) {
        this.resetData()
        setTimeout(() => {
          const focusedField: any = this.$refs['focusedField']
          if (focusedField) {
            focusedField.focus()
          }
        }, 0)
      }
    },

    isUpdate (newVal: boolean): void {
      if(newVal) {
        setTimeout(() => {
          const focusedField: any = this.$refs['focusedField']
          if (focusedField) {
            focusedField.focus()
          }
        }, 0)
      }
    },

    storageData (newVal: any): void {
      if(newVal) {
        this.setData()
      }
    },

  },

  computed: {
    snackbarColor (): boolean {
      return this.snackbarState === SnackbarStateEnum.Success
    },

    selectedLocale(): string {
      return this.$store.getters[GET_SELECTED_UI_LANGUAGE].code
    },

    isReadonlyFields (): boolean {
      if(this.isCreate || this.isUpdate) {
        return false
      } else {
        return true
      }
    }
  },

  methods: {
    onEinlagermengeChange (): void {
      if(this.einlagermenge == null || this.einlagermenge < 0) {
        this.einlagermenge = null
      }
    },

    onCancelClick (): void {
      this.setData()
      this.$emit('onCancelClick')
    },

    setData (): void {

    },

    resetData (): void {

    }
  },

  mounted () {
    this.setData()
  }

})
